import { render, staticRenderFns } from "./FlashSale.vue?vue&type=template&id=9823e748&scoped=true"
import script from "./FlashSale.vue?vue&type=script&lang=js"
export * from "./FlashSale.vue?vue&type=script&lang=js"
import style0 from "./FlashSale.vue?vue&type=style&index=0&id=9823e748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9823e748",
  null
  
)

export default component.exports